import { Avatar } from '@mui/material';
import { StepIconProps } from '@mui/material/StepIcon';
import {
  DeniedStep,
  LastStep,
  PurpleCheckMark,
  RequestsStepperActive,
  StepperIcon,
} from 'Images';

export interface ICustomStepperIcon extends Partial<StepIconProps> {
  active?: boolean;
  completed?: boolean;
  isLastStep?: boolean;
  isDenied?: boolean;
}

export const CustomStepperIcon = ({
  active = false,
  completed = false,
  isLastStep = false,
  isDenied = false,
}: ICustomStepperIcon) => {
  let avatarSrc = () => {
    if (isLastStep) return isDenied ? DeniedStep : LastStep;
    if (active) return RequestsStepperActive;
    if (completed) return PurpleCheckMark;
    return StepperIcon;
  };

  return (
    <Avatar
      src={avatarSrc()}
      alt=''
      sx={{
        width: '24px',
        height: '24px',
      }}
    />
  );
};
